module.exports = __webpack_public_path__ + "img/3_Bericht_Entladen.2d39b8e9.svg";